import styled from 'styled-components';

const StatCard = ({ icon, title, value, color }) => {
    return (
        <CardWrapper>
            <MainContent>
                <TextContent>
                    <CardTitle>{title}</CardTitle>
                    <CardValue>{value}</CardValue>
                </TextContent>
                <IconWrapper color={color}>
                    {icon}
                </IconWrapper>
            </MainContent>
            <BottomAccent color={color} />
        </CardWrapper>
    );
};

export default StatCard;

// Styled Components

const CardWrapper = styled.div`
    background: ${({ theme }) => theme.colors.surface || '#ffffff'};
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid ${({ theme }) => theme.colors.border || '#e5e7eb'};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    height: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    min-height: 140px;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
        border-color: ${({ theme }) => theme.colors.brandLighter || 'rgba(112, 26, 130, 0.2)'};
    }
`;

const MainContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.75rem;
    z-index: 2;
`;

const TextContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    min-width: 0; /* Fix flex text overflow */
`;

const CardTitle = styled.h5`
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textMuted || '#6b7280'};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const CardValue = styled.p`
    font-size: 1.625rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.textPrimary || '#111827'};
    margin: 0;
    line-height: 1.2;
`;

const IconWrapper = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 1rem;
    background-color: ${({ theme, color }) => {
        const c = theme.colors[color] || theme.colors.neutral || '#333';
        return `${c}15`; // Add 15% opacity to the hex color
    }};
    color: ${({ theme, color }) => theme.colors[color] || theme.colors.neutral || '#333'};

    svg {
        width: 24px;
        height: 24px;
        fill: currentColor;
    }

    /* Fallback for icon size if it's not an SVG (e.g. font icon) */
    font-size: 1.5rem;
`;

const BottomAccent = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: ${({ theme, color }) => theme.colors[color] || theme.colors.neutral || '#333'};
    opacity: 0.7;
`;
